"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _APIs = require("../../constants/APIs");
var _SuggestBox = _interopRequireDefault(require("../materials/SuggestBox"));
var _CallAPI = require("../system/CallAPI");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StyledSuggestBox = (0, _styles.styled)(_SuggestBox.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(2)
  };
});

/**
 * 拠点選択部品
 * @prop {string} [value] - 選択している拠点番号
 * @prop {string} kaishaCd - 会社コード
 * @prop {string} areaCd - 地域コード
 * @prop {string} areaNm - 地域名
 * @prop {function} onAreaSiteChange - 変更された拠点のデータを受け取る関数
 * シグネチャ：function(obj)) => void
 * obj：選択された拠点情報オブジェクト
 * { siteNo:string, siteBuildingNm:string }
 */

class SelectSite extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "INIT_STATE", {
      kaishaCd: '',
      areaCd: '',
      siteInfo: []
    });
    _defineProperty(this, "RESULT", {
      areaCd: '',
      areaNm: '',
      siteNo: '',
      siteBuildingNm: '',
      tdfkCd: ''
    });
    _defineProperty(this, "handleOnChange", value => {
      const {
        areaCd,
        areaNm,
        onAreaSiteChange
      } = this.props;
      const selectSite = this.state.siteInfo.find(item => item.siteNo === value);
      if (selectSite === undefined) {
        this.RESULT.areaCd = areaCd;
        this.RESULT.areaNm = areaNm;
        this.RESULT.siteNo = null;
        this.RESULT.siteBuildingNm = '';
        this.RESULT.tdfkCd = '';
      } else {
        this.RESULT.areaCd = selectSite.areaCd;
        this.RESULT.areaNm = selectSite.areaNm;
        this.RESULT.siteNo = selectSite.siteNo;
        this.RESULT.siteBuildingNm = this.getSiteBuildingName(selectSite);
        this.RESULT.tdfkCd = selectSite.tdfkCd;
      }
      onAreaSiteChange(this.RESULT);
    });
    this.state = _objectSpread({}, this.INIT_STATE);
    const {
      kaishaCd,
      areaCd: _areaCd
    } = this.props;
    if (kaishaCd !== '' && _areaCd !== '') {
      this.callApiSearch(kaishaCd, _areaCd);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      kaishaCd,
      areaCd
    } = this.props;
    if (kaishaCd) {
      if (prevProps.kaishaCd !== kaishaCd || prevProps.areaCd !== areaCd) {
        this.callApiSearch(kaishaCd, areaCd);
      }
    }
  }
  callApiSearch(kaishaCd, areaCd) {
    const sendData = {
      kaishaCd: kaishaCd,
      areaCd: areaCd
    };
    this.props.callAPI(_APIs.AREA_SITE_SELECT_SEARCH, sendData).then(json => {
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        siteInfo: json.data ? json.data : []
      }));
    });
  }
  getSiteBuildingName(data) {
    return data.buildingNm + ' ' + data.siteNm;
  }
  render() {
    const {
      value,
      areaCd,
      error,
      helperText
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        xs: 8
      }
    }, /*#__PURE__*/_react.default.createElement(StyledSuggestBox, {
      value: value === null ? '' : value,
      onChange: this.handleOnChange,
      items: areaCd ? this.state.siteInfo.map(data => {
        return {
          displayName: this.getSiteBuildingName(data),
          value: data.siteNo
        };
      }) : [],
      error: !!error,
      helperText: helperText
    }))));
  }
}
SelectSite.propTypes = {
  value: _propTypes.default.string,
  kaishaCd: _propTypes.default.string.isRequired,
  areaCd: _propTypes.default.string,
  areaNm: _propTypes.default.string,
  onAreaSiteChange: _propTypes.default.func.isRequired,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.string
};
var _default = exports.default = (0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(SelectSite));